import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: []
    },
    lastName: {
      validations: []
    },
    clientname: {
      validations: []
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    sitename: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    eventdate: {
      validations: []
    },
    theme: {
      validations: []
    },
    reference: {
      validations: []
    },

  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Name of Organization:',
            mapping: 'clientname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone / Extension: *',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email: *',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Location (venue name & city):',
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventdate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Name:',
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Referred By:',
            mapping: 'headerLabel'
          }
        ]
      },
      {
        fields: [
          {
            type: 'radio-buttons',
            size: 'Medium',
            label: '',
            options: [
              { label: 'Salesperson call/contact', value: 'Salesperson call/contact'},
              { label: 'Direct Mailing/Print Media/Radio', value: 'Direct Mailing/Print Media/Radio' },
              { label: 'Social Media', value: 'Social Media' },
              { label: 'Internet Search', value: 'Internet Search' },
              { label: 'Trade Show', value: 'Trade Show' },
              { label: 'I have used Nelson’s before', value: 'I have used Nelson’s before' },
              { label: 'Personal Reference/Recommendation', value: 'Personal Reference/Recommendation' },
              { label: 'Chamber Mailing', value: 'Chamber Mailing' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'reference',
            customClasses: ['form-check-label']['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'GALA / SPECIAL EVENT FORM',
    formId: '238',
    clientKey: '5EE2A7BA-1D6F-4DB2-95B0-ED35B78C0FAD',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/nelsons3/form_structure.js